require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-recruiting-revealed-understanding-the-role-of-recruiters.json") })
        }
      }, "path---blog-recruiting-revealed-understanding-the-role-of-recruiters");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-recruiting-revealed-understanding-the-role-of-recruiters!./.cache/json/blog-recruiting-revealed-understanding-the-role-of-recruiters.json
// module id = 1024
// module chunks = 231608221292675